module.exports = __webpack_public_path__ + "img/face-1.7d013863.png";